export default "__VITE_ASSET__BxrQCXq8__"